// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","wrapper":"_31y7GItexOA2ap5VhztTYb","post":"_2DAhEOh-PDHAEzMtpGlGbA","userEngagement":"_1Y7CUkWzQuxe_WCTQMuh1w"};